<script>
	import lookups from "../stores/lookupStore";
	import Person from "../models/Person";

	import TextInput from "./TextInput.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import DatePicker from "./DatePicker.svelte";

	export let claimantDetails;
	export let claimants;
	export let disabled = null;

	if (!claimants || !claimants.length) {
		claimants = [new Person()];
	}

	console.log(claimants[0].dateOfBirth);

	console.log(claimants[0].firstName);
	console.log(claimants);
</script>

<FormRow>
	<FormColumn>
		<h2>Claimant Details</h2>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<TextInput label="First name" required {disabled} bind:value={claimants[0].firstName} id="s_firstName" />
	</FormColumn>
	<FormColumn cols="6">
		<TextInput label="Last name" required {disabled} bind:value={claimants[0].surname} id="s_surname" />
	</FormColumn>
</FormRow>
<FormRow>
	<FormColumn cols="6">
		<DatePicker
			required
			label="Date of birth"
			placeholder="Date of birth"
			{disabled}
			validator={true}
			start={new Date(1921, 0, 1)}
			end={new Date()}
			bind:formattedSelected={claimants[0].dateOfBirth}
			openOnClass="calendar-icon"
		/>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Checkbox
			required
			{disabled}
			bind:checked={claimantDetails.authorisedToAct}
			label="I am authorised to act on behalf of the Individual"
			id="auth"
		></Checkbox>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Select
			label="Capacity"
			required
			{disabled}
			id="cap"
			bind:value={claimantDetails.capacityId}
			optionList={$lookups.someoneElseCapacity}
			textProperty="lookupName"
			valueProperty="id"
		></Select>
	</FormColumn>
</FormRow>
